export type BuildListIncidentsPathParams = {
  page: number;
  limit: number;
  q?: string;
};

export function buildListIncidentsPath(
  params: BuildListIncidentsPathParams,
): string {
  const searchParams = new URLSearchParams({
    page: String(params.page),
    limit: String(params.limit),
  });

  if (params.q?.trim()) {
    searchParams.set('q', params.q.trim());
  }

  return `/api/v1/incidents?${searchParams.toString()}`;
}
